export default {
      id: "weekgrid-usage",
      viewBox: "0 0 17 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#weekgrid",
      toString: function () {
        return this.url;
      }
    }